import { render, staticRenderFns } from "./materialReservationDetail.vue?vue&type=template&id=8d704746&scoped=true"
import script from "./materialReservationDetail.vue?vue&type=script&lang=js"
export * from "./materialReservationDetail.vue?vue&type=script&lang=js"
import style0 from "./materialReservationDetail.vue?vue&type=style&index=0&id=8d704746&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d704746",
  null
  
)

export default component.exports